const SVG = ({ fill = '#E64C41', width = '14', height = '10', viewBox = '0 0 14 10' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.092.047H2.908A2.908 2.908 0 000 2.954v4.092a2.908 2.908 0 002.908 2.908h8.184A2.908 2.908 0 0014 7.046V2.955A2.908 2.908 0 0011.092.047zM9.126 5.199L5.298 7.025a.154.154 0 01-.22-.139V3.121c0-.115.12-.19.223-.137l3.828 1.94a.154.154 0 01-.003.275z" />
  </svg>
)

export default SVG
